export interface IRelayoutHeightSpecifiable {
  relayoutHeight: number;
}

export function instanceOfIRelayoutHeightSpecifiable(instance: any): instance is IRelayoutHeightSpecifiable {
  return instance
    && (instance.relayoutHeight !== undefined);
}
